import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { Radio } from '@crehana/compass.ui';
import clsx from 'clsx';
import { UserOrganizationRoleEnum } from "../../../../__generated__/globals.v5";
import { useProfileUITranslations } from "../i18n";
import { useUserRole } from "./hooks/useUserRole";
import Subtitle from "./Subtitle";
import { UserPermissions } from "./UserPermissions/UserPermissions";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RoleSelector = function RoleSelector(_ref) {
  var options = _ref.options,
    defaultSelected = _ref.defaultSelected,
    organizationSlug = _ref.organizationSlug,
    enableUserPermissions = _ref.enableUserPermissions,
    isSupplanting = _ref.isSupplanting;
  var _useProfileUITranslat = useProfileUITranslations(),
    t = _useProfileUITranslat.t;
  var _useUserRole = useUserRole(),
    role = _useUserRole.role;
  var _useState = useState(defaultSelected),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var isSubAdmin = role === UserOrganizationRoleEnum.SUBADMIN;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('tw-w-full tw-mt-2 tw-pt-2', 'tw-border-solid tw-border-t dark:tw-border-t-neutral-dark-700', isSupplanting ? 'tw-border-t-neutral-dark-300' : 'tw-border-t-neutral-light-300'),
    children: [/*#__PURE__*/_jsx(Subtitle, {
      label: t('PROFILE_PANEL'),
      className: "tw-px-0.8"
    }), /*#__PURE__*/_jsx("ul", {
      className: "tw-flex tw-flex-col tw-items-start",
      children: options.map(function (option, index) {
        return /*#__PURE__*/_jsx(Radio, {
          className: "".concat(index !== 0 ? 'tw-mt-1.2' : '', " tw-gap-0.8 tw-px-0.8"),
          size: "s",
          onChange: function onChange() {
            if (option.value !== selectedOption.value) {
              setSelectedOption(option);
              window.location.href = option.url;
            }
          },
          checked: selectedOption.value === option.value,
          title: option.label
        }, option.value);
      })
    }), isSubAdmin && enableUserPermissions && /*#__PURE__*/_jsx(UserPermissions, {
      organizationSlug: organizationSlug
    })]
  });
};
export default RoleSelector;